import { api } from "./client";

export interface RacingSectorTime {
  sector_index: number;
  duration_seconds: number;
}

export interface RacingRankingRow {
  rank: number;
  user_id: number;
  username: string;
  best_lap_seconds: number;
  best_lap_flight_id: number;
  best_lap_flight_title: string | null;
  best_lap_session_name: string | null;
  sectors: RacingSectorTime[];
}

export interface RacingBestSector {
  sector_index: number;
  duration_seconds: number;
  user_id: number | null;
  username: string | null;
  flight_id: number | null;
}

export interface RacingRankingsOut {
  mission: string;
  rows: RacingRankingRow[];
  best_sectors: RacingBestSector[];
}

export interface RacingLiveSession {
  user_id: number;
  username: string | null;
  key: string;
  mission_name: string | null;
  flight_frame_count: number;
  info_count: number;
}

export interface RacingLiveSessionsOut {
  available: boolean;
  sessions: RacingLiveSession[];
}

export interface RacingLiveSessionBundleOut {
  user_id: number;
  username: string | null;
  key: string;
  info: Record<string, unknown> | null;
  info_history: Record<string, unknown>[];
  flight_history: Record<string, unknown>[];
}

export function getRacingRankings(limit = 10) {
  return api.get<RacingRankingsOut>(
    `/api/racing/rankings?limit=${encodeURIComponent(String(limit))}`,
  );
}

export function getRacingLiveSessions() {
  return api.get<RacingLiveSessionsOut>(`/api/racing/live/sessions`);
}

export function getRacingLiveSessionBundle(userId: number, key: string) {
  return api.get<RacingLiveSessionBundleOut>(
    `/api/racing/live/sessions/${userId}/${encodeURIComponent(key)}`,
  );
}

export interface RacingPilotSectorTime {
  sector_index: number;
  duration_seconds: number;
}

export interface RacingPilotBestOut {
  user_id: number;
  username: string | null;
  mission: string;
  best_lap_seconds: number | null;
  best_lap_flight_id: number | null;
  best_lap_sectors: RacingPilotSectorTime[];
  best_sectors: RacingPilotSectorTime[];
}

export function getRacingPilotBest(userId: number) {
  return api.get<RacingPilotBestOut>(`/api/racing/pilots/${userId}/best`);
}
